<style scoped lang="scss" type="text/scss">
    .info-panel-container {
        display: flex;
        align-items: flex-start;

        font-size: .85rem;

        .icon {
            font-size: 1.5rem;
            margin-right: .5rem;
            line-height: 1.5rem;
        }

        &.warning .icon {
            color: #ff4d51;
        }

        &.small {
            font-size: .75rem;

            .icon {
                font-size: 1rem;
                margin-right: .5rem;
            }
        }

        .text {
            line-height: 1.5rem;
        }
    }
</style>

<template>
    <div class="info-panel-container" :class="{'small': 'small' === size, 'warning': type === 'warning'}">
        <i class="icon" v-html="icon"></i>
        <div class="text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            size: String,
            type: {
                type: String,
                default: 'tip'
            }
        },
        data () {
            return {};
        },
        computed: {
            icon () {
                if ('title' === this.type) {
                    return '&#xe6b4;';
                } else if ('tip' === this.type) {
                    return '&#xe602;';
                } else if ('warning' === this.type) {
                    return '&#xe69a;';
                } else {
                    return '';
                }
            }
        }
    };
</script>
